import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { chunk } from 'lodash'
import workOrderCalendar from '../../services/workOrderCalendar.service'
import { RootState } from '../../store'
import { previousMonth, nextMonth, CalendarDate } from '../../views/WorkOrderCalendar/WorkOrderCalendar.slice'
import Heading from '../Heading'
import Icon from '../Icon'
import Date from './Date'

interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class Calendar extends Component<CombinedProps> {
  constructor (props: CombinedProps) {
    super(props)
    this.handlePreviousMonthClick = this.handlePreviousMonthClick.bind(this)
    this.handleNextMonthClick = this.handleNextMonthClick.bind(this)
  }

  handlePreviousMonthClick () {
    this.props.previousMonth()
  }

  handleNextMonthClick () {
    this.props.nextMonth()
  }

  tableRow (dates: (CalendarDate | null)[], index: number) {
    return (
      <tr key={index}>
        {dates.map((date, index) => {
          return (
            <td className="border cursor-pointer hover:bg-yellow-50" key={index}>
              <div className="align-top h-[117px]">
                <Date date={date} />
              </div>
            </td>
          )
        })}
      </tr>
    )
  }

  get heading () {
    const { monthName, year } = this.props
    return `${monthName} ${year}`
  }

  get tableRows () {
    const rows = chunk(this.props.dates, 7)
    return rows.map((row, index) => this.tableRow(row, index))
  }

  render () {
    return (
      <div className="overflow-x-scroll">
        <table className="border table-fixed w-[800px] lg:w-full">
          <thead className="text-left">
            <tr>
              <th className="p-0" colSpan={7}>
                <div className="flex justify-between">
                  <Heading size="small" className="px-4 py-2" text={this.heading} />
                  <div className="inline-flex">
                    <Icon
                      className="h-full border-l flex items-center px-2 hover:text-gray-500"
                      size="medium"
                      name="arrow-left"
                      color="gray"
                      onClick={this.handlePreviousMonthClick} />
                    <Icon
                      className="h-full border-l flex items-center px-2 hover:text-gray-500"
                      size="medium"
                      name="arrow-right"
                      color="gray"
                      onClick={this.handleNextMonthClick} />
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th className="px-3 py-1.5 border">Sun</th>
              <th className="px-3 py-1.5 border">Mon</th>
              <th className="px-3 py-1.5 border">Tue</th>
              <th className="px-3 py-1.5 border">Wed</th>
              <th className="px-3 py-1.5 border">Thu</th>
              <th className="px-3 py-1.5 border">Fri</th>
              <th className="px-3 py-1.5 border">Sat</th>
            </tr>
          </thead>
          <tbody>
            {this.tableRows}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { month, year, dates } = state.workOrderCalendar
  const monthName = workOrderCalendar.getMonthName(month)
  return { monthName, year, dates }
}

const mapDispatchToProps = {
  previousMonth,
  nextMonth
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(Calendar)
